// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"nordics_breadcrumbs__sLQcH"};